import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	dialog: {
		// eslint-disable-next-line
		zIndex: "999999 !important" as any,
	},
})

export default useStyles
